import React, {ComponentType, Suspense} from "react";

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
const NS = 'TimelineV2Loader';

const ThemeWrap = function() {
  // window.__PIXI_APP__ only has value until this component is loaded
  const TimelineV2 = React.lazy(() =>
    import('./TimelineV2ReactContainer')
  );
  return <Suspense fallback={<div>Loading...</div>}>
    <TimelineV2 useKeepPixiApp={false} />
  </Suspense>
}
/**
 * Returns properties needed for rendering react2angular
 */
export const R2ATimelineV2: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>
];

